import React from "react";
import Svg, { Path } from "react-native-svg";
import { TouchableOpacity } from "react-native";

import AppTheme from "../../AppTheme";

export default function AddIcon(props) {
  const color = props.color || AppTheme.DEFAULT_COLOR;
  const width = props.width || 16;
  const height = props.height || 16;

  return (
    <TouchableOpacity style={props.style} {...props}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          d="M8.32024 4.76903C8.17856 4.76885 8.04263 4.82505 7.94244 4.92524C7.84226 5.02542 7.78605 5.16135 7.78623 5.30303L7.78699 7.78677L5.30325 7.78601C5.00833 7.78601 4.76924 8.0251 4.76924 8.32002C4.76924 8.61495 5.00833 8.85403 5.30325 8.85403L7.78699 8.85328L7.78623 11.337C7.78623 11.6319 8.02532 11.871 8.32024 11.871C8.61516 11.871 8.85425 11.6319 8.85425 11.337L8.85349 8.85328L11.3372 8.85403C11.528 8.85403 11.7043 8.75225 11.7997 8.58703C11.8951 8.4218 11.8951 8.21824 11.7997 8.05302C11.7043 7.8878 11.528 7.78602 11.3372 7.78602L8.85349 7.78677L8.85425 5.30303C8.85442 5.16135 8.79822 5.02542 8.69804 4.92524C8.59785 4.82505 8.46192 4.76885 8.32024 4.76903Z"
          fill={color}
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.91992 8.31992C1.91992 4.7853 4.7853 1.91992 8.31992 1.91992C11.8531 1.92345 14.7164 4.78676 14.7199 8.31992C14.7199 11.8545 11.8545 14.7199 8.31992 14.7199C4.7853 14.7199 1.91992 11.8545 1.91992 8.31992ZM2.98659 8.31995C2.98659 11.2655 5.3744 13.6533 8.31992 13.6533C9.73441 13.6533 11.091 13.0914 12.0912 12.0912C13.0913 11.091 13.6533 9.73444 13.6533 8.31995C13.6533 5.37443 11.2654 2.98662 8.31992 2.98662C5.3744 2.98662 2.98659 5.37443 2.98659 8.31995Z"
          fill={color}
        />
      </Svg>
    </TouchableOpacity>
  );
}
